import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
// import {
//   addArtisanPublicInquiryAction,
//   editArtisanPublicInquiryAction,
//   getArtisanPublicInquiryAction,
// } from '../../../../modules/inquiries/artisans/public/Actions';

import {
  inquiryByIdSelector,
  artisanPublicInquiriesIsLoadingSelector
} from '../../../../../modules/myInquiries/Artisan/Public/Selectors';

// import { getArtisansAction } from '../../../../modules/artisans/Actions';
import {
  getMyArtisanPublicInquiryAction,
  addMyPublicArtisanProposalAction
} from '../../../../../modules/myInquiries/Artisan/Public/Actions';
// import { artisansAsLabelAndValueSelector } from '../../../../modules/artisans/Selectors';

import { getArtisanProductsAction } from '../../../../../modules/artisanProducts/Actions';
import { artisanProductByIdSelector } from '../../../../../modules/artisanProducts/Selectors';

import {
  InputField,
  TextArea,
  Select,
  FormSectionTitle,
  Upload
} from '../../../../../components/form';

import FormGroup from '../../../../../components/form/FormGroup';
import { artisanDataSelector } from '../../../../../modules/auth/Selectors';
import getLangData from '../../../../../utils/getLangData';

const ViewPublicInquiry = props => {
  const {
    isLoading,
    pendingIsLoading,

    inquiryID,

    inquiry,
    getPublicInquiry,
    moderateCreateArtisanPublicInquiry,
    getArtisans,
    artisanSingleProduct,
    getArtisanProducts,
    artisan,
    addPublicIquiry,
    editPublicInquiry,
    addProposal,
    artisanData
  } = props;

  const [open, setOpen] = useState(false);
  // for testing only
  const artisanId = artisanData._id;
  const { trusted } = artisanData;
  const lang = getLangData().fields
  useEffect(() => {
    getArtisanProducts();
    getPublicInquiry(inquiryID);
  }, [inquiryID, getPublicInquiry]);

  useEffect(() => { }, []);

  console.log(inquiry, 'inquiry');
  return (
    <div>
      <Formik
        enableReinitialize
        initialValues={{
          ...inquiry
          // price: 0,
          // message: '',
          // attachment: '',
          // inquiryId: inquiry?._id,
          // artisanId: ''
        }}
        onSubmit={values => {
          const data = {
            inquiryId: inquiry._id,
            artisanId: artisanId,
            price: values.proposals[0].price,
            message: values.proposals[0].message,
            attachment: values.proposals[0].attachment
          };
          //  const productName = artisanProducts.find((item) => values.aproductId === item.value);
          //  values.aproductName = productName.label
          // const data = {
          //   ...values,
          //   customerId,
          // };
          // if (inquiryID === 'create') {
          //   addPublicIquiry(data);
          //   console.log(productName.label);
          // } else {
          //   editPublicInquiry(values._id, data);
          // }\
          console.log(data);
          addProposal(data, trusted);
        }}
      >
        {({ values, handleSubmit, setFieldValue }) => {
          return (
            <FormGroup
              handleSubmit={handleSubmit}
              heading={lang.view_private_inquiry}
              isLoading={isLoading || pendingIsLoading}
              noSubmit={inquiry?.proposals?.length > 0}
            // btnType="Contact User"
            >
              {inquiry && (
                <div className='row mb-5 ' style={{ maxHeight: '300px' }}>
                  <div
                    className='col-md-6 col-sm-12'
                    style={{ maxHeight: '300px' }}
                  >
                    <img src={inquiry.attachment} />
                  </div>
                  <div className='col-md-6 col-sm-12'>
                    <h1>{inquiry.title}</h1>
                    <p>{inquiry.message}</p>
                    <p>{inquiry.customerData.businessName}</p>
                    {!open && inquiry?.proposals?.length === 0 && (
                      <button
                        className='btn btn-primary'
                        onClick={() => setOpen(true)}
                      >
                        {lang.add_propsal}
                      </button>
                    )}
                  </div>
                </div>
              )}
              {/* <InputField
                name='customerData.businessName'
                label='Customer Name'
                disabled
              />
              <TextArea name='message' label='Message' disabled />
              <Upload
                disabled={true}
                data={{ userID: artisanId }}
                name='attachment'
                label='Inquiry Image :'
                S3Bucket='warshatna-users'
                // API="customer/customer-category-image-signedurl/"
                API='users/user-profile-image-signedurl'
              /> */}
              {/* <InputField name='artisanDetail.businessName' label='Artisan Name' /> */}

              {/* <InputField name='aproductId.name' label='Product Name' /> */}
              {/* <InputField name="artisanProduct.name" label="Product" disabled/> */}
              {/* {console.log(values.aproductId)} */}
              {/* <Select
              label="Product"
              name=" "
              // value={artisanProducts.filter(
              //   (object) => values.aproductId.indexOf((object.value) > -1)
              // )}
              options={artisanProducts}
            /> */}
              {/* <TextArea
              name="aproductId.description"
              label="Product Description"
            /> */}

              {/* <InputField name="qtyRequired" label="Quantity Required" disabled /> */}
              {inquiry?.proposals?.length > 0 && (
                <>
                  <FormSectionTitle>My Proposal</FormSectionTitle>
                  <InputField
                    name='proposals[0].price'
                    label={lang.price}
                    type='number'
                    disabled
                  />
                  <TextArea
                    disabled
                    name='proposals[0].message'
                    label={lang.my_message}
                  />
                  <div style={{ maxHeight: '300px' }}>
                    <img src={inquiry.proposals[0].attachment} />
                  </div>

                  {/* <Upload
                    data={{ userID: artisanId }}
                    name='proposals[0].attachment'
                    label='Inquiry Image :'
                    S3Bucket='warshatna-users'
                    // API="customer/customer-category-image-signedurl/"
                    API='users/user-profile-image-signedurl'
                  /> */}
                </>
              )}
              {open && (
                <>
                  <FormSectionTitle>{lang.my_proposal}</FormSectionTitle>
                  <InputField
                    name='proposals[0].price'
                    label={lang.price}
                    type='number'
                  />
                  <TextArea name='proposals[0].message' label={lang.my_message} />
                  <Upload
                    data={{ userID: artisanId }}
                    name='proposals[0].attachment'
                    label={`${lang.inquiry_image} :`}
                    S3Bucket='warshatna-users'
                    // API="customer/customer-category-image-signedurl/"
                    API='users/user-profile-image-signedurl'
                  />
                </>
              )}
            </FormGroup>
          );
        }}
      </Formik>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const inquiryID = props.match.params.id;
  const moderationId = props.match.params.moderationId;
  return {
    inquiryID,
    moderationId,
    inquiry: inquiryByIdSelector(state, inquiryID),
    isLoading: artisanPublicInquiriesIsLoadingSelector(state),
    // artisan: artisansAsLabelAndValueSelector(state),
    // artisanProducts: artisansProductsAsLabelAndValueSelector(state),
    artisanSingleProduct: artisanProductByIdSelector(state, props.id),
    artisanData: artisanDataSelector(state)
  };
};

const mapDispatchToProps = {
  getPublicInquiry: getMyArtisanPublicInquiryAction,
  addProposal: addMyPublicArtisanProposalAction,
  // getArtisans: getArtisansAction,
  getArtisanProducts: getArtisanProductsAction
  // editPublicInquiry: editArtisanPublicInquiryAction,
  // addPublicIquiry: addArtisanPublicInquiryAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPublicInquiry);
